import useAccountInfo from 'hooks/account/useAccountInfo';
import useMultiOrgAccessRequestList from 'hooks/useMultiOrgAccessRequestList';
import { Dialog, DialogContent, DialogHeader, DialogMain } from 'stylus-ui/Dialog';
import { Table, TableBody, TableHead, TableHeader, TableRow } from 'stylus-ui/Table';
import { isSuperOrgPlanEnterprise } from 'utils/helper';
import { AccessRequestsForOrg, InvitedUser } from 'v2/types';

import { BaseModalProps } from '../BaseModal';
import UserRequest from './UserRequest';

export type ApproveAccessModalProps = BaseModalProps;

const ApproveAccessTeamRow = ({ invitedUser }) => {
  const isEnterpriseSuperOrg = isSuperOrgPlanEnterprise(invitedUser.organization.super_organization);

  return (
    <UserRequest
      teamId={invitedUser.organization.id}
      teamName={invitedUser.organization.name}
      email={invitedUser.invited_user_email}
      name={invitedUser.invited_user_name}
      isEnterpriseSuperOrg={isEnterpriseSuperOrg}
    />
  );
};

export const ApproveAccessModal = ({ visible, onCancel }: ApproveAccessModalProps) => {
  const { data: account } = useAccountInfo();
  const { accessRequests, isLoading, error } = useMultiOrgAccessRequestList(account?.organizations);

  if (isLoading) return null;

  if (error) {
    // eslint-disable-next-line no-console
    console.error('Approve Access Modal Error: ', error);
    return null;
  }

  const dataForRow = accessRequests.map((accessRequestsForOrg: AccessRequestsForOrg) => accessRequestsForOrg?.requests).flat();

  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onCancel?.()}>
      <DialogContent className='flex w-full min-w-[720px] max-w-max'>
        <DialogHeader title='Team access requests' />
        <DialogMain>
          {accessRequests?.every((request: AccessRequestsForOrg) => request?.requests.length === 0) ? (
            <>All clear! No team access requests.</>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>User</TableHead>
                  <TableHead>Team</TableHead>
                  <TableHead>Role</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {dataForRow?.map((invitedUser: InvitedUser) => (
                  <ApproveAccessTeamRow key={invitedUser.invite_code} invitedUser={invitedUser} />
                ))}
              </TableBody>
            </Table>
          )}
        </DialogMain>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveAccessModal;
